import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import usePriceTypes from "../../../../prices/hooks/usePriceTypes";
import { formatPrice } from "../../../../prices/utils/priceFormatters";

import PublisherPriceDropdownMenu from "../components/PublisherPriceDropdownMenu";

export default function usePublisherPricesTableColumns({ publisher, organization }) {
	const { t } = useTranslation();

	const priceTypeNames = usePriceTypes();

	return useMemo(
		() => [
			{
				id: "price.type",
				Header: t("type", "Type"),
				accessor: ({ price }) => priceTypeNames[price.type],
			},
			{
				id: "price",
				Header: t("price", "Price"),
				accessor: ({ price }) => price && `${price.name} (${formatPrice(price)})`,
			},
			{
				id: "agreement.name",
				Header: t("agreement", "Agreement"),
				Cell: ({ value }) => value,
			},
			{
				id: "remove",
				collapsing: true,
				Cell: ({ row }) => (
					<PublisherPriceDropdownMenu
						publisher={publisher}
						organization={organization}
						price={row.original}
					/>
				),
			},
		],
		[t, priceTypeNames, publisher, organization],
	);
}
